import { Injectable } from '@angular/core';
import { IHasIdAndName } from '../interfaces/has-id-and-name.interface';
import { IListItem } from '../interfaces/ilist-item.interface';
import { AlertDialogComponent, AlertDialogModel } from '../dialogs/alert/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ItemTypeEnum } from '../enums/item-type.enum';
import { FormInstance } from '../models/site-content/form-instance.model';

export class CutOrCopiedItem {
    public static readonly COPIED: string = 'copied';
    public static readonly CUT: string = 'cut';
    public static readonly FOLDER: string = 'folder';
    public static readonly FORMINSTANCE: string = 'forminstance';

    private cutOrCopied: string;
    private type: string;
    private id: number;
    private name: string;
    constructor(id: number, type: string, cutOrCopied: string, name: string = "") {
        this.id = id;
        this.type = type;
        this.cutOrCopied = cutOrCopied;
        this.name = name;
    }

    public IsCopiedFormInstance(): boolean {
        return this.cutOrCopied == CutOrCopiedItem.COPIED && this.type == CutOrCopiedItem.FORMINSTANCE;
    }

    public IsCutFormInstance(): boolean {
        return this.cutOrCopied == CutOrCopiedItem.CUT && this.type == CutOrCopiedItem.FORMINSTANCE;
    }

    public IsCopiedFolder(): boolean {
        return this.cutOrCopied == CutOrCopiedItem.COPIED && this.type == CutOrCopiedItem.FOLDER;
    }

    public IsCutFolder(): boolean {
        return this.cutOrCopied == CutOrCopiedItem.CUT && this.type == CutOrCopiedItem.FOLDER;
    }

    public get Id(): number {
        return this.id;
    }

    public get Name(): string {
        return this.name;
    }

    public set Name(value) {
        this.name = value;
    }

}

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {

    private copiedItems: IListItem[] = [];
    private cutItems: IListItem[] = [];
    private allCopiedAreReferences: boolean;

    // New For Tree and Forms Grid integration
    private cutOrCopiedItem: CutOrCopiedItem;
    private copiedFormInstanceToPaste: number;
    private cutFormInstanceToPaste: number;
    private copiedFolderToPaste: number;

    constructor(public dialog: MatDialog) { }

    public set CopiedFormInstanceToPaste(value: number) {
        this.cutOrCopiedItem = new CutOrCopiedItem(value, CutOrCopiedItem.FORMINSTANCE, CutOrCopiedItem.COPIED);
    }

    public set CopiedFolderToPaste(value: number) {
        this.cutOrCopiedItem = new CutOrCopiedItem(value, CutOrCopiedItem.FOLDER, CutOrCopiedItem.COPIED);
    }

    public set CutFormInstanceToPaste(value: number) {
        this.cutOrCopiedItem = new CutOrCopiedItem(value, CutOrCopiedItem.FORMINSTANCE, CutOrCopiedItem.CUT);
    }

    public set CutFolderToPaste(value: number) {
        this.cutOrCopiedItem = new CutOrCopiedItem(value, CutOrCopiedItem.FOLDER, CutOrCopiedItem.CUT);
    }

    public set CutFolderNameToPaste(value: string) {
        this.cutOrCopiedItem.Name = value;
    }

    public get CutOrCopiedItem(): CutOrCopiedItem {
        return this.cutOrCopiedItem;
    }

    public get HasItemToPaste(): boolean {
        return this.cutOrCopiedItem != null;
    }

    //public get CopiedFormInstanceToPaste(): number {
    //    return this.copiedFormInstanceToPaste;
    //}

    //public get CutFormInstanceToPaste(): number {
    //    return this.cutFormInstanceToPaste;
    //}

    public reInit() {
        this.copiedItems = [];
        this.cutItems = [];
        this.cutOrCopiedItem = null;
    }

    public copyItemsToClipboard(items: IListItem[]) {
        let types = new Set(items.map(x => x.getType()));
        let refs = items.filter(x => { return x.getType() == ItemTypeEnum.FORM_INSTANCE }).filter((x: FormInstance) => { return x.isReference });
        this.allCopiedAreReferences = refs.length == items.length;

        if (types.size > 1) {
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: new AlertDialogModel("Item type mismatch", `You can only copy items of the same type, folders or forms.`)
            });

        }
        this.copiedItems = items;
    }

    public cutItemsToClipboard(items: IListItem[]) {
        let types = new Set(items.map(x => x.getType()));
        if (types.size > 1) {
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: new AlertDialogModel("Item type mismatch", `You can only copy items of the same type, folders or forms.`)
            });

        }
        this.cutItems = items;
    }

    public get CopiedItems(): IListItem[] {
        return this.copiedItems;
    }

    public get CutItems(): IListItem[] {
        return this.cutItems;
    }

    public getCopiedItemsOfType(types): any[] {
        if (!this.copiedItems) {
            return [];
        } else {
            return this.copiedItems.filter(x => { return types.includes(x.getType()) });
        }
    }

    public getCutItemsOfType(types): any[] {
        if (!this.CutItems) {
            return [];
        } else {
            return this.cutItems.filter(x => { return types.includes(x.getType()) });
        }
    }

    public hasCopiedItemsOfType(type: string[]) {
        return this.getCopiedItemsOfType(type).length > 0;
    }

    public hasCutItemsOfType(type: string[]) {
        return this.getCutItemsOfType(type).length > 0;
    }

    public get AllCopiedAreReferences(): boolean {
        return this.allCopiedAreReferences;
    }
}
